module.exports = __webpack_public_path__ + "img/C13.ddfe3273.png";